import * as Sentry from '@sentry/react';
import type { BackendTypes } from '@tf/api';
import { Button, Icon, TFNotifier, useDisclosure } from '@tf/ui';
import type React from 'react';
import { useNavigate } from 'react-router-dom';

import { useProfileLabelByContext } from '@/core/hooks';
import { UserCapabilities } from '@/core/types';
import { useCurrentUserCapabilityCheck } from '@/core/utils';

import { AddProfileModal } from './AddProfileModal';

export const AddProfileButton: React.FC = () => {
	const canEditAccounts = useCurrentUserCapabilityCheck(UserCapabilities.CAN_PREPARE_ACCOUNTS_DATA);
	const contextLabel = useProfileLabelByContext();

	const addAccountModal = useDisclosure();
	const navigate = useNavigate();
	const onSuccess = ({ connectedEntityId }: { connectedEntityId: BackendTypes.GraphId }) => {
		TFNotifier.success(`${contextLabel.singularCapitalized} created`);
		navigate(`/accounts/${connectedEntityId}`);
	};

	const onError = (err: Error) => {
		const message = `Couldn't create ${contextLabel.singular}`;
		Sentry.captureException(new Error(message, { cause: err }));
		TFNotifier.error(message);
	};

	return canEditAccounts ? (
		<>
			<Button leftSection={<Icon.IconPlus size={18} stroke={2.25} />} onClick={addAccountModal.open}>
				{`Add ${contextLabel.singular}`}
			</Button>

			<AddProfileModal
				title={`Add ${contextLabel.singular}`}
				opened={addAccountModal.isOpen}
				onClose={addAccountModal.close}
				contentProps={{ onSuccess, onError }}
			/>
		</>
	) : null;
};
